class SlurrpTV extends HTMLElement {
  constructor() {
    super()
    this.currentSlide = 0
    this.slides = []
    // Declare clevertap variable
    this.clevertap = window.clevertap
  }

  connectedCallback() {
    this.slides = this.querySelectorAll('.slurrpfarm-video-slide')
    this.totalSlides = this.slides.length

    this.bindControls()
    this.showSlide(this.currentSlide)
  }

  bindControls() {
    // Play button click
    this.querySelectorAll('.slurrpfarm-play-button').forEach((btn, index) => {
      btn.addEventListener('click', () => {
        this.playVideo(index, btn)
      })
    })

    // Arrow controls
    const nextBtn = this.querySelector('[data-slurrp-next]')
    const prevBtn = this.querySelector('[data-slurrp-prev]')

    if (nextBtn) {
      nextBtn.addEventListener('click', () => this.nextVideo())
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => this.previousVideo())
    }
  }

  showSlide(index) {
    this.slides.forEach((slide) => {
      slide.classList.remove('active')

      const iframe = slide.querySelector('.slurrpfarm-video-player')
      const thumbnail = slide.querySelector('.slurrpfarm-video-thumbnail')
      const playButton = slide.querySelector('.slurrpfarm-play-button')

      if (iframe) {        
        iframe.src = ''
        iframe.classList.remove('active')
      }

      if (thumbnail) thumbnail.style.display = 'block'
      if (playButton) playButton.classList.remove('hidden')
    })

    if (this.slides[index]) {
      this.slides[index].classList.add('active')
      this.currentSlide = index
    }
  }

  nextVideo() {
    const nextIndex = (this.currentSlide + 1) % this.totalSlides
    this.showSlide(nextIndex)
  }

  previousVideo() {
    const prevIndex =
      (this.currentSlide - 1 + this.totalSlides) % this.totalSlides
    this.showSlide(prevIndex)
  }

  playVideo(index, buttonEl) {
    const slide = this.slides[index]
    if (!slide) return

    const videoId = slide.getAttribute('data-video-id')
    const iframe = slide.querySelector('.slurrpfarm-video-player')
    const thumbnail = slide.querySelector('.slurrpfarm-video-thumbnail')
    const playButton = slide.querySelector('.slurrpfarm-play-button')

    if (!videoId || !iframe) {
      return
    }

    if (thumbnail) thumbnail.style.display = 'none'
    if (playButton) playButton.classList.add('hidden')

    // Include fs=0 to hide fullscreen button and allow single-click play
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&fs=0`
    iframe.classList.add('active')

    // CleverTap Event
    const eventData = {
      "Video URL": buttonEl.dataset.url,
      "Video position": index + 1,
      "Video name": buttonEl.dataset.name
    }

    if (this.clevertap?.event) {
      this.clevertap.event.push('home_SF_TV_played', eventData)
    }
  }
}

customElements.define('slurrp-tv', SlurrpTV)
